import React from "react";
import styled from "styled-components";
import { Switch } from "antd";
import { useTranslation } from "react-i18next";

import * as gtag from "../../../../../lib/gtag";

import { Container, Title } from "./FilterComponents";

const SwitchContainer = styled.div`
  display: flex;
  align-items: center;

  .switch-text {
    margin-left: 8px;
    max-width: 140px;
    color: #747d84;
    font-size: 10px;
  }
`;

export default function ReferralFilter({ active, onChange, loading }) {
  const { t } = useTranslation();

  return (
    <details data-test="filter-referral" open={active}>
      <Title>
        <h4>{t("opportunity:candidates.referralFilter.title")}</h4>
      </Title>
      <Container>
        <SwitchContainer>
          <Switch
            checked={active}
            onChange={e => {
              onChange(e);
              gtag.event({
                category: "VacancyCandidates",
                action: `filterReferred`
              });
            }}
            disabled={loading}
            data-test="referral-filter-switch"
          />
          <span className="switch-text">
            {t(
              "opportunity:candidates.referralFilter.referredByCompanyEmployees"
            )}
          </span>
        </SwitchContainer>
      </Container>
    </details>
  );
}
